class BgInverted extends HTMLElement {

  constructor() {
    super();
    this.header = document.querySelector('.header');
  }

  connectedCallback() {
    setTimeout(() => {
      this.header.classList.add('header-inverted')
    }, 300);
  }

  disconnectedCallback() {
    setTimeout(() => {
      this.header.classList.remove('header-inverted')
    }, 300);
  }

}


// Define the new web component
if ('customElements' in window) {
  customElements.define('bg-inverted', BgInverted);
}
